import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // Retorno do logout do Azure AD: limpa AMBOS os storages (token em sessionStorage,
    // demais chaves em localStorage). O próprio template exibe o link "ENTRAR" (/authenticate).
    localStorage.clear();
    sessionStorage.clear();
  }

}
